export default "__VITE_ASSET__965cbf2e__"